module.exports = __webpack_public_path__ + "img/mid_banner.4e863066.png";